<script>
import Layout from '@layouts/main'
import { merchantComputed, authComputed } from '@state/helpers'
import MemberBanner from '@components/MemberBanner'
import OrderList from './components/OrderList'

export default {
  page() {
    return {
      title: this.$t('global.MEMBER_ORDER'/* 我的結緣 */),
    }
  },
  components: { Layout, OrderList, MemberBanner },
  props: {
    orders: {
      type: Array,
      required: true,
    },
    pagination: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      filterStatus: {
        name: 'status',
        list: [
          {
            text: this.$t('global.STATUS_ALL' /* 所有狀態 */),
            value: ''
          },
          {
            text: `${this.$t('global.PAID' /* 已付款 */)}`,
            value: '1'
          },
          {
            text: this.$t('global.CANCELED' /* 已取消 */),
            value: '0'
          },
          {
            text: `${this.$t('global.UNPAID' /* 未付款 */)}`,
            value: '2'
          },
          {
            text: `${this.$t('global.PROCESS' /* 待處理 */)}`,
            value: '3'
          },
          {
            text: `${this.$t('global.COMPLETE' /* 已完成 */)}`,
            value: '4'
          },
        ],
        value: this.$route.query.status
      },
      filterOrder: {
        name: 'orderBy',
        list: [
          {
            text: this.$t('global.ORDER_BY_CREATED' /* 依結緣成立時間 */),
            value: 'created'
          },
          {
            text: this.$t('global.ORDER_BY_START_DATE' /* 依活動開始時間 */),
            value: 'startDate'
          },
        ],
        value: this.$route.query.orderBy
      },
    }
  },
  computed: {
    ...merchantComputed,
    ...authComputed,
  },
  methods: {
    handleChangeFilter(value, name) {
      this.$router.push({
        query: {
          ...this.$route.query,
          p: 1,
          [name]: value
        }
      })
    },
  },
}
</script>
<template>
  <Layout>
    <div class="booking-container">
      <MemberBanner :member="currentMember"/>
      <div class="booking-section">
        <div class="level subsection is-auto-style">
          <h4 class="level-left booking-section__title">
            {{ $t('global.MEMBER_ORDER'/*我的結緣*/) }}
          </h4>
          <div class="level-right">
            <div class="buttons is-filter-style">
              <BaseFilter
                v-model="filterStatus.value"
                :name="filterStatus.name"
                icon="filter"
                :select="filterStatus.list"
                @change="handleChangeFilter"
              />
              <BaseFilter
                v-model="filterOrder.value"
                :name="filterOrder.name"
                icon="sort-amount-up"
                :select="filterOrder.list"
                @change="handleChangeFilter"
              />
            </div>
          </div>
        </div>
        <div
          v-if="orders.length > 0"
          class="subsection product-wrapper"
        >
          <OrderList :orders="orders"/>
        </div>
        <div v-else class="subsection">
          {{ $t('global.MEMBER_ORDER_NULL'/*沒有任何結緣紀錄或沒有符合搜尋條件的結緣*/) }}
        </div>
      </div>
      <BasePagination v-if="orders.length > 0" :pagination="pagination"/>
    </div>
  </Layout>
</template>
